module.exports = __webpack_public_path__ + "static/img/6.0f4fd8f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/testimages/6.png
// module id = JjPg
// module chunks = 1